import React, { FC, createContext, useState, PropsWithChildren, useContext } from 'react';

import { WizardStepProps } from 'vibo-ui/Wizard/interfaces';

import { WizardStateResponse } from './interfaces';

export const WizardContext = createContext<WizardStateResponse>(undefined!);

export const useWizard = () => useContext(WizardContext);

export const WizardState: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [wizardRefProps, setWizardRefProps] = useState<Nullable<WizardStepProps>>(null);

  return (
    <WizardContext.Provider value={{ wizardRefProps, setWizardRefProps }}>
      {children}
    </WizardContext.Provider>
  );
};
